import { Trans, useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useIsMobile } from '@scramble/hooks';
import { Button } from '@scramble/ui';
import s from './index.module.scss';

const id = MODAL_IDS.not_crowdfunding_notice;

export const NotCrowdfundingNoticeModal = ({ onAccept }) => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal onAccept={onAccept} />;
};

export const Modal = ({ onAccept }) => {
  const isMobile = useIsMobile();
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const onClose = () => {
    closeModal(id);
  };

  const onUnderstand = () => {
    onClose();
    onAccept?.();
  };

  const content = (
    <div className={s.modal}>
      <div className={s.header}>
        <div className={s.title}>
          {t('modal:not_crowdfunding_notice_modal.title')}
        </div>
      </div>
      <div className={s.content}>
        <p>
          <Trans
            ns="modal"
            i18nKey="not_crowdfunding_notice_modal.paragraph_1"
            components={{ b: <span className="f-600" /> }}
          />
        </p>
        <p>
          <Trans
            ns="modal"
            i18nKey="not_crowdfunding_notice_modal.paragraph_2"
            components={{ b: <span className="f-600" /> }}
          />
        </p>
      </div>
      <div className={s.footer}>
        <Button
          theme="neutral"
          appearance="tonal"
          size="lg"
          label={t('modal:not_crowdfunding_notice_modal.cancel')}
          onClick={onClose}
        />
        <Button
          theme="neutral"
          appearance="filled"
          size="lg"
          label={t('modal:not_crowdfunding_notice_modal.understand')}
          onClick={onUnderstand}
        />
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalCenterLayout>
  );
};
